import app from '../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { CandidateSuccessScreenContainer } from './CandidateSuccessScreen.container';

app.component(
  'candidateSuccessScreen',
  react2angular(CandidateSuccessScreenContainer, [], ['config', 'httpApi', 'logger']),
);
